export interface IMerchant {
  id?: string;
  name?: string | null;
  imagePath?: string | null;
  coverPhoto?: string | null;
  category?: string | null;
  description?: string | null;
}

export const defaultValue: Readonly<IMerchant> = {};
